const config = {
	testUrl: 'https://feemfundy.herokuapp.com/api',
	liveUrl: 'https://feemfundy.herokuapp.com/api',
}

export default config
